import clsx from "classnames";
import classes from "./styles.module.scss";
import Link from 'next/link';
export default function EventCard({ resource, className }) {

  function formatDate(date) {
    const dateObject = new Date(date);

    if (isNaN(dateObject)) {
      return '';
    }

    const day = dateObject.getDate();
    const month = dateObject.toLocaleString('en-US', { month: 'short' });
    const year = dateObject.getFullYear();

    const outputDate = `${day} ${month.toUpperCase()} ${year}`;

    return outputDate
  }

  return (
    <Link href={"/blog/" + resource.url_slug} passHref>
      <div className={clsx(className, classes.resource_card)}>
        <img className={classes.resource_image} src={resource.image} alt={resource.title}></img>
        <div className={classes.resource_detail}>
          <div className={classes.detail_card}>
            <div className={classes.header}>
              <div className={classes.tag}>{resource.tag || 'Event'}</div>
              {resource.eventdate &&
                <div className={classes.read_time}>
                  <img src="/icons/calendar.png" alt="calendar"></img>
                  <div className={classes.duration}>{formatDate(resource.eventdate)}</div>
                </div>
              }
            </div>
            <h3 className={classes.title}>{resource.title}</h3>
            {resource.eventlocation &&
              <div className={classes.contacts}>
                <div className={classes.location}><img src="/icons/location_pink.png" alt="location"/><span>{resource.eventlocation?.join(' / ')}</span></div>
              </div>
            }
          </div>
        </div>
      </div>
    </Link>
  );
}

EventCard.defaultProps = {
  className: "",
};
